// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-ai-chat-button {
  z-index: 999;
  position: absolute;
  right: 116px;
  bottom: 36px;
  transition: right 0.3s cubic-bezier(0.53, 0.99, 0.61, 1.03), opacity 0.2s;
}
.fi-ai-chat-button.hidden {
  opacity: 0;
  pointer-events: none;
}
.fi-ai-chat-button .ai-chat-mat-icon-button .mat-icon {
  font-size: 22px;
  width: unset;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-ai-chat/fi-ai-chat-button/fi-ai-chat-button.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yEAAA;AACF;AAEE;EACE,UAAA;EACA,oBAAA;AAAJ;AAII;EACE,eAAA;EACA,YAAA;AAFN","sourcesContent":[".fi-ai-chat-button {\r\n  z-index: 999;\r\n  position: absolute;\r\n  right: 116px;\r\n  bottom: 36px;\r\n  transition: right 0.3s cubic-bezier(0.53, 0.99, 0.61, 1.03), opacity 0.2s;\r\n\r\n  // hidden under AI panel when AI panel is opened\r\n  &.hidden {\r\n    opacity: 0;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .ai-chat-mat-icon-button {\r\n    .mat-icon {\r\n      font-size: 22px;\r\n      width: unset;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
